import { User } from '../../shared/models/user.model';
export class PeopleInvolved {
    PeopleInvolvedId: number;
    IncidentRequestId: number;
    UserId: number = 1;
    UserIncident : User = {
            UserId: 1,
            Email: 'b44hse1@arapetroleum.com',
            FirstName: 'b44hse1',
            LastName: '',
            FullName: 'b44hse1',
            UserTypeId: 1,
            UserTypes:  {
                InActive: false,
                UserType: 'Employee',
                UserTypeId: 1
            },
            ContactNumber: 1122334455,
            Designation: 'Design',
            DepartmentName: '',
            ContractNumber:'',
            UserTypeName:''
        
    };
    Job: number = 1;
    Injury: string = 'Injury';
    Company: string;
}
